/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairPassengerRequest } from '../../models/finnair-passenger-request';

export interface UpdatePassengerDetailsInCart$Params {
  cartId: string;
  locale?: string;
  hash?: string;
      body: FinnairPassengerRequest
}

export function updatePassengerDetailsInCart(http: HttpClient, rootUrl: string, params: UpdatePassengerDetailsInCart$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, updatePassengerDetailsInCart.PATH, 'put');

  if (params) {
    rb.path('cartId', params.cartId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

updatePassengerDetailsInCart.PATH = '/api/v2/cart/{cartId}/passengers';
